import {Component, OnInit, ViewChild} from '@angular/core';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {TranslocoService} from '@ngneat/transloco';
import {MachineListComponent} from './components/machines/machine-list.component';
import {LoggedUser} from './common/logged-user.service';
import {Toast} from "primeng/toast";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  title: string = 'frontend';
  showMenu: boolean = true;
  authenticated: boolean = false;

  @ViewChild(Toast)
  toast: Toast | undefined;

  @ViewChild(MachineListComponent, {static: false})
  landingComponent: MachineListComponent;

  constructor(private primengConfig: PrimeNGConfig,
              private i18n: TranslocoService,
              private messageService: MessageService,
              private loggedUser: LoggedUser) {
    loggedUser.userObservable.subscribe(user => this.authenticated = user !== undefined);
  }

  ngOnInit(): void {
    this.i18n.getTranslation('es');
    this.i18n.setDefaultLang('es');
    this.i18n.setActiveLang('es');
    this.primengConfig.ripple = true;
  }

}
